import AssessmentPackagesContainer from './AssessmentPackagesContainer'
export default AssessmentPackagesContainer
